/* eslint-disable import/no-unresolved */
import { sortBy } from 'lodash';
import { parseDatabaseValue } from 'utillities';
import { alphabetGenerator } from 'utillities/alphabet-utilities';

// period columns are reverse parsed here
const CURRENCY_DECIMAL_PLACES = 2;
const reverseParser = ({ cells, columns, rowConfig, allowEmptyValues = true, tableData, sheet, fieldAttributes }) => {
  let tableColumns = [];
  const { dcfPeriodAttrs } = fieldAttributes;
  const sortedColumns = sortBy(columns, ['order']);
  const alphabet = alphabetGenerator([], sortedColumns.length);

  sortedColumns.forEach((column, columnIndex) => {
    const columnLegend = alphabet[columnIndex];

    // copy original values
    let tmpColumn = { ...column };

    // replace updated values
    rowConfig.forEach((cell, cellIndex) => {
      const key = columnLegend + (cellIndex + 1);
      const defaultValue = cell.defaultValue || null;
      const decimalPlaces = dcfPeriodAttrs[cell.alias]?.decimal_places || CURRENCY_DECIMAL_PLACES;
      const value = parseDatabaseValue({
        type: cell?.dbType,
        value: cells[key] ? cells[key].value : defaultValue,
        defaultValue,
        format: cell?.format,
        allowEmptyValues,
        dontMultiply: true,
        gridType: cell.gridType,
        decimalPlaces,
      });

      if (cell.alias && cells[key]) {
        tmpColumn = {
          ...tmpColumn,
          [cell.alias]: value,
        };
      }
      if (cell.alias && cell.rowNumberPair) {
        const tempCell = cells[key];
        const { alias, isCellCalculated } = tempCell;
        const cellEnabledAlias = `${alias}_enabled`;

        tmpColumn = {
          ...tmpColumn,
          [cellEnabledAlias]: !isCellCalculated,
        };
      }
    });

    tableColumns = [...tableColumns, tmpColumn];
  });
  // eslint-disable-next-line no-param-reassign
  sheet.columns = tableColumns;
  // eslint-disable-next-line no-param-reassign
  tableData.approach.valuations_approach_dcf.dcf_financial_period = tableColumns;
};

export default reverseParser;
